import React, { createContext, useContext, useEffect, useState } from 'react';

interface ContextValue {
	isAuth: boolean;
}

const AuthContext = createContext<ContextValue | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
	// 로그인 여부
	const [isAuth, setAuth] = useState<boolean>(!!window.sessionStorage.getItem('accessToken'));

	const handleLogin = () => {
		setAuth(!!window.sessionStorage.getItem('accessToken'));
	};

	// auth event 발생 시 isLogin 업데이트
	useEffect(() => {
		window.addEventListener('auth', handleLogin);
		return () => {
			window.removeEventListener('auth', handleLogin);
		};
	}, []);

	return <AuthContext.Provider value={{ isAuth }}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => {
	const state = useContext(AuthContext);
	if (!state) {
		throw new Error('Cannot find AuthProvider');
	}
	return state;
};
